let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eipnW")).then(() => parcelRequire('3AA8L'));